import { render, staticRenderFns } from "./FilterStars.vue?vue&type=template&id=656a9932&scoped=true&"
import script from "./FilterStars.vue?vue&type=script&lang=ts&"
export * from "./FilterStars.vue?vue&type=script&lang=ts&"
import style0 from "./FilterStars.vue?vue&type=style&index=0&id=656a9932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a9932",
  null
  
)

export default component.exports